import { Th, Flex, Box } from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon, UpDownIcon } from "@chakra-ui/icons";
import {
  fixedColumnStyle,
  headerCellStyles,
  headerCellTagStyles,
} from "../../../utils/styles/tableStyles";
import { Dispatch, FC, SetStateAction } from "react";
import { FixedColumn } from "./FixedColumn";
import { getFixedColumnProps } from "./helpers/getFixedColumnProps";
import { useFixedColumnWidths } from "./hooks/useFixedColumnWidths";

interface TableHeaderProps {
  column: any;
  columnsStyle?: string[];
  fixedColumnIds?: FixedColumn[];
  hasScroll: boolean;
  hasColSpanGreaterThanOne: boolean;
  setFixedColumnWidths: Dispatch<SetStateAction<number[]>>;
  fixedColumnWidths: number[];
}

const TableHeader: FC<TableHeaderProps> = ({
  column,
  columnsStyle,
  fixedColumnIds,
  hasScroll,
  hasColSpanGreaterThanOne,
  setFixedColumnWidths,
  fixedColumnWidths,
}) => {
  const headerRef = useFixedColumnWidths(
    column.id,
    fixedColumnIds,
    setFixedColumnWidths,
  );
  const columnSpan = column.columns ? column.columns.length : 1;
  const hasChildren = column.columns && column.columns.length > 0;
  const hasNoParentAndNoChildren = !column.parent && !hasChildren;
  const isStyled = columnsStyle?.some((colId) => column.id.includes(colId));

  const { fixedColumn, rightOffset } = getFixedColumnProps(
    column.id,
    fixedColumnIds,
    fixedColumnWidths,
  );

  const renderSortIcon = () => {
    if (column.disableSortBy) return null;
    if (column.isSorted) {
      return column.isSortedDesc ? (
        <TriangleDownIcon ms={1} />
      ) : (
        <TriangleUpIcon ms={1} />
      );
    }
    return <UpDownIcon ms={1} />;
  };

  return (
    <Th
      {...column.getHeaderProps(column.getSortByToggleProps())}
      colSpan={columnSpan}
      sx={{
        backgroundColor: isStyled ? "gray.100" : "white",
        ...(hasChildren ? headerCellTagStyles : headerCellStyles),
        py: hasColSpanGreaterThanOne ? "2" : "4",
        ...(fixedColumn &&
          hasScroll && {
            ...fixedColumnStyle,
            right: `${rightOffset}px`,
          }),
      }}
      key={column.id}
      ref={headerRef}
    >
      <Flex
        alignItems="center"
        justifyContent={
          ["edit", "delete", "download", "ver"].includes(column.id)
            ? "end"
            : "start"
        }
        maxHeight="4"
        mt={hasColSpanGreaterThanOne && hasNoParentAndNoChildren ? "-6" : "0px"}
      >
        {hasChildren ? (
          <Box textAlign="center" width="100%">
            {column.render("Header")}
          </Box>
        ) : (
          column.render("Header")
        )}
        {column.depth === 0 && renderSortIcon()}
      </Flex>
    </Th>
  );
};

export default TableHeader;
